type Props = {
  fillColor?: string;
};

export const ExpandIcon = ({ fillColor = '#757575' }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12.0001 15.6016L5.9751 9.60156L18.0251 9.60156L12.0001 15.6016Z" fill={fillColor} />
  </svg>
);
